export default {
	primary_first: "",
	primary_last: "",
	primary_email: "",
	primary_occupation: "",
	primary_employer: "",
	primary_age: "",
	has_co: false,
	co_first: "",
	co_last: "",
	co_email: "",
	co_occupation: null,
	co_employer: "",
	co_age: "",
	buyer_address: "",
	buyer_city: "",
	buyer_state: "",
	buyer_zip: "",
	buyer_country: "",
	buyer_phone: "",
	first_time: "",
	is_moving_within: "",
	has_extended_fam: "",
	num_residents: "",
	purchase_reason: "",
	other_communities_considered: "",
	notes: "",
	is_relo: null,
	num_children: "",
	married: "",
	household_income: "",
	addl: {}
}